import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[login-company-host]',
    standalone: false
})
export class LoginCompanyDirective {
  constructor(public viewContainerRef: ViewContainerRef) {
  }
}